import gql from "graphql-tag";

//GetChildPermitCountByDateRange
export const GET_DASHBOARD_3_GENERAL_VS_TOOL_INSTALL = gql`
    query ($year: String!, $sites: [String!]!) {
        GeneralAndToolInstallPermitCount(year: $year, sites: $sites) {
            code
            success
            message
            results {
                key
                month
                generalPermitCount
                toolPermitCount
            }
        }
    }
`;